(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["export-pallets"] && !Shopify.designMode) return;
  try {
    
(function() {
  var tabContainer = document.querySelector('.ph-tabs-scroll');
  if (tabContainer) {
    tabContainer.addEventListener('click', function(e) {
      var tab = e.target.closest('.ph-tab');
      if (!tab) return;
      var idx = tab.dataset.tab;
      document.querySelectorAll('.ph-tab').forEach(function(t) {
        t.classList.remove('active');
        t.setAttribute('aria-selected', 'false');
      });
      document.querySelectorAll('.ph-product-card').forEach(function(c) {
        c.classList.remove('active');
      });
      tab.classList.add('active');
      tab.setAttribute('aria-selected', 'true');
      var card = document.getElementById('card-' + idx);
      if (card) card.classList.add('active');
    });
  }
  document.querySelectorAll('.ph-faq-q').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.closest('.ph-faq-item');
      var isOpen = item.classList.contains('is-open');
      var answer = item.querySelector('.ph-faq-a');
      if (isOpen) {
        item.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
        answer.setAttribute('hidden', '');
      } else {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        answer.removeAttribute('hidden');
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new"] && !Shopify.designMode) return;
  try {
    

(function() {

  // Tab switching
  var tabContainer = document.querySelector('.ph-tabs-scroll');
  if (tabContainer) {
    tabContainer.addEventListener('click', function(e) {
      var tab = e.target.closest('.ph-tab');
      if (!tab) return;
      var idx = tab.dataset.tab;

      document.querySelectorAll('.ph-tab').forEach(function(t) {
        t.classList.remove('active');
        t.setAttribute('aria-selected', 'false');
      });
      document.querySelectorAll('.ph-product-card').forEach(function(c) {
        c.classList.remove('active');
      });

      tab.classList.add('active');
      tab.setAttribute('aria-selected', 'true');
      var card = document.getElementById('card-' + idx);
      if (card) card.classList.add('active');
    });
  }

  // FAQ accordion
  document.querySelectorAll('.ph-faq-q').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.closest('.ph-faq-item');
      var isOpen = item.classList.contains('is-open');
      var answer = item.querySelector('.ph-faq-a');

      if (isOpen) {
        item.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
        answer.setAttribute('hidden', '');
      } else {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        answer.removeAttribute('hidden');
      }
    });
  });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pallets-hub"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.ph-faq-q').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.closest('.ph-faq-item');
      var isOpen = item.classList.contains('is-open');
      var answer = item.querySelector('.ph-faq-a');
      if (isOpen) {
        item.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
        answer.setAttribute('hidden', '');
      } else {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        answer.removeAttribute('hidden');
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pine-pallets"] && !Shopify.designMode) return;
  try {
    

(function() {

  // FAQ accordion
  document.querySelectorAll('.ph-faq-q').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.closest('.ph-faq-item');
      var isOpen = item.classList.contains('is-open');
      var answer = item.querySelector('.ph-faq-a');

      if (isOpen) {
        item.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
        answer.setAttribute('hidden', '');
      } else {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        answer.removeAttribute('hidden');
      }
    });
  });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-form"] && !Shopify.designMode) return;
  try {
    
(function() {

  var PALLET_TYPES = [
    'Pine Pallets',
    'Hardwood Pallets',
    'Export / Air Freight Pallets',
    'Heat Treated Pallets',
    'Euro Pallets / 4 Way Entry Pallets',
    'Skids',
    'Custom Pallets'
  ];

  var DUNNAGE_TYPES = [
    'Dunnage',
    'Pipe Retainers',
    'Grooved Dunnage',
    'Hardwood Dunnage',
    'Export Dunnage'
  ];

  var currentProduct = 'Pallets';
  var lineCount = 0;

  function getCategory() {
    if (currentProduct === 'Crates') return 'Crates';
    if (currentProduct === 'Dunnage') return 'Dunnage';
    return 'Pallets';
  }

  function buildTypeOptions() {
    var cat = getCategory();
    var list = cat === 'Dunnage' ? DUNNAGE_TYPES : PALLET_TYPES;
    var placeholder = cat === 'Crates' ? 'Crate type' : cat === 'Dunnage' ? 'Dunnage type' : 'Pallet type';
    var html = '<option value="" disabled selected>' + placeholder + '</option>';
    list.forEach(function(t) {
      html += '<option value="' + t + '">' + t + '</option>';
    });
    return html;
  }

  function updateColHeader() {
    var el = document.getElementById('qf-col-type-label');
    var headers = document.getElementById('qf-col-headers');
    var cat = getCategory();
    if (headers) headers.style.display = cat === 'Crates' ? 'none' : '';
    if (el) el.textContent = cat === 'Dunnage' ? 'Dunnage Types' : 'Pallet Types';
  }

  function buildLine(idx) {
    var cat = getCategory();
    var removeBtn = idx > 0
      ? '<button type="button" class="qf-btn-remove" aria-label="Remove line" title="Remove">&#8722;</button>'
      : '';
    var actionsHtml = '<div class="qf-line-actions">'
      + '<button type="button" class="qf-btn-add" aria-label="Add line" title="Add line">&#43;</button>'
      + removeBtn
      + '</div>';

    if (cat === 'Crates') {
      return '<div class="qf-line qf-line--crate" data-idx="' + idx + '">'
        + '<div class="qf-crate-inner">'
        +   '<div class="qf-crate-dims-wrap">'
        +     '<span class="qf-crate-label">Internal Dimensions</span>'
        +     '<div class="qf-line-dims">'
        +       '<input class="qf-input" type="number" min="1" placeholder="W(mm)" data-field="w" aria-label="Width">'
        +       '<span class="qf-dim-sep">X</span>'
        +       '<input class="qf-input" type="number" min="1" placeholder="L(mm)" data-field="l" aria-label="Length">'
        +       '<span class="qf-dim-sep">X</span>'
        +       '<input class="qf-input" type="number" min="1" placeholder="H(mm)" data-field="h" aria-label="Height">'
        +     '</div>'
        +   '</div>'
        +   '<div class="qf-crate-qty-wrap">'
        +     '<span class="qf-crate-label">Qty:</span>'
        +     '<input class="qf-input" type="number" min="1" placeholder="Qty" data-field="qty" aria-label="Qty">'
        +   '</div>'
        + '</div>'
        + actionsHtml
        + '</div>';
    }

    var showH = cat === 'Dunnage';
    var dimsHtml = '<input class="qf-input" type="number" min="1" placeholder="W(mm)" data-field="w" aria-label="Width">'
      + '<span class="qf-dim-sep">X</span>'
      + '<input class="qf-input" type="number" min="1" placeholder="L(mm)" data-field="l" aria-label="Length">';
    if (showH) {
      dimsHtml += '<span class="qf-dim-sep">X</span>'
        + '<input class="qf-input" type="number" min="1" placeholder="H(mm)" data-field="h" aria-label="Height">';
    }

    return '<div class="qf-line" data-idx="' + idx + '">'
      + '<select class="qf-select" data-field="type" aria-label="Type">' + buildTypeOptions() + '</select>'
      + '<div class="qf-line-dims">' + dimsHtml + '</div>'
      + '<input class="qf-input" type="number" min="1" placeholder="Qty" data-field="qty" aria-label="Qty">'
      + actionsHtml
      + '</div>';
  }

  function renderLines() {
    var container = document.getElementById('qf-lines');
    if (!container) return;
    container.innerHTML = '';
    lineCount = 0;
    addLine();
    updateColHeader();
  }

  function addLine() {
    var container = document.getElementById('qf-lines');
    if (!container) return;
    var div = document.createElement('div');
    div.innerHTML = buildLine(lineCount);
    var line = div.firstChild;
    container.appendChild(line);
    line.querySelector('.qf-btn-add').addEventListener('click', addLine);
    var removeBtn = line.querySelector('.qf-btn-remove');
    if (removeBtn) {
      removeBtn.addEventListener('click', function() { line.remove(); });
    }
    lineCount++;
  }

  function collectLines() {
    var container = document.getElementById('qf-lines');
    if (!container) return [];
    var results = [];
    container.querySelectorAll('.qf-line').forEach(function(line) {
      var typeEl = line.querySelector('[data-field="type"]');
      var qtyEl  = line.querySelector('[data-field="qty"]');
      var wEl    = line.querySelector('[data-field="w"]');
      var lEl    = line.querySelector('[data-field="l"]');
      var hEl    = line.querySelector('[data-field="h"]');
      results.push({
        type: typeEl ? (typeEl.value || '(not selected)') : '',
        qty:  qtyEl  ? (qtyEl.value  || '—') : '—',
        w:    wEl    ? wEl.value : '',
        l:    lEl    ? lEl.value : '',
        h:    hEl    ? hEl.value : ''
      });
    });
    return results;
  }

  function buildBody() {
    var lines    = collectLines();
    var name     = (document.getElementById('qf-name')     || {}).value || '';
    var company  = (document.getElementById('qf-company')  || {}).value || '';
    var phone    = (document.getElementById('qf-phone')    || {}).value || '';
    var email    = (document.getElementById('qf-email')    || {}).value || '';
    var street   = (document.getElementById('qf-street')   || {}).value || '';
    var suburb   = (document.getElementById('qf-suburb')   || {}).value || '';
    var state    = (document.getElementById('qf-state')    || {}).value || '';
    var postcode = (document.getElementById('qf-postcode') || {}).value || '';
    var notes    = (document.getElementById('qf-message')  || {}).value || '';
    var exportEl  = document.querySelector('input[name="qf_export_treatment"]:checked');
    var exportVal = exportEl ? exportEl.value : 'No';

    var body = '=== QUOTE REQUEST ===\n\n';
    body += 'PRODUCT TYPE: ' + currentProduct + '\n';
    body += 'EXPORT TREATMENT: ' + exportVal + '\n\n';
    body += '--- ITEMS REQUESTED ---\n';
    lines.forEach(function(l, i) {
      body += 'Item ' + (i + 1) + ':\n';
      if (l.type) body += '  Type: ' + l.type + '\n';
      var dims = [l.w, l.l, l.h].filter(Boolean).join(' x ');
      if (dims) body += '  Dimensions: ' + dims + 'mm\n';
      body += '  Quantity: ' + l.qty + '\n';
    });
    body += '\n--- CUSTOMER DETAILS ---\n';
    body += 'Name: '    + name    + '\n';
    body += 'Company: ' + company + '\n';
    body += 'Phone: '   + phone   + '\n';
    body += 'Email: '   + email   + '\n';
    body += 'Delivery address: ' + street + '\n';
    body += '                  ' + suburb + ' ' + state + ' ' + postcode + '\n';
    if (notes) body += '\nNotes: ' + notes + '\n';
    return body;
  }

  document.addEventListener('DOMContentLoaded', function() {

    renderLines();

    document.querySelectorAll('input[name="qf_product_type"]').forEach(function(radio) {
      radio.addEventListener('change', function() {
        currentProduct = this.value;
        renderLines();
      });
    });

    var form = document.getElementById('qf-form');
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var bodyEl  = document.getElementById('qf-body');
        var errorEl = document.getElementById('qf-error');
        var valid = true;

        form.querySelectorAll('[required]').forEach(function(el) {
          if (!el.value.trim()) {
            valid = false;
            el.style.borderColor = '#e74c3c';
          } else {
            el.style.borderColor = '';
          }
        });

        if (!valid) {
          if (errorEl) errorEl.removeAttribute('hidden');
          return;
        }

        if (errorEl) errorEl.setAttribute('hidden', '');
        if (bodyEl) bodyEl.value = buildBody();

        fetch('/contact#contact_form', {
          method: 'POST',
          body: new FormData(form)
        }).then(function() {
          var modal = document.getElementById('qf-success-modal');
          if (modal) modal.style.display = 'flex';
        });
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
